import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDocker,
  faGit,
  faJenkins,
  faLinux,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCloud,
  faNetworkWired,
  faRoute,
  faServer,
  faShieldAlt,
  faChartLine,
  faGears,
  faDesktop,
} from "@fortawesome/free-solid-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../hooks/usePageTitle";

const categories = [
  {
    icons: [faLinux, faCloud, faServer],
    titleKey: "systemCloudTitle",
    descKey: "systemCloudDesc",
    tags: [
      "GCP", "AZURE","CLOUDFLARE","PROXMOX",
      "UBUNTU", "DEBIAN", "NAS",
      "HAPROXY", "NGINX", "SCALEWAY", "MAILGUN",
    ],
  },
  {
    icons: [faNetworkWired, faRoute, faShieldAlt],
    titleKey: "networkSecurityTitle",
    descKey: "networkSecurityDesc",
    tags: [
      "WAN", "LAN", "ROUTAGE", "SWITCH",
      "VPN", "IPsec", "VLAN", "OSPF",
      "DHCP", "DNS", "PFSENSE", "FORTINET",
      "STORMSHIELD",
    ],
  },
  {
    icons: [faDocker, faGit, faGears],
    titleKey: "devopsTitle",
    descKey: "devopsDesc",
    tags: [
      "GIT", "GITLAB", "TERRAFORM",
      "KUBERNETES", "HELM", "MICROK8S",
      "DOCKER", "ARGOCD", "JENKINS",
      "ANSIBLE", "BASH", "JIRA", "CONFLUENCE",
    ],
  },
  {
    icons: [faChartLine, faGoogle, faDesktop],
    titleKey: "monitoringAdminTitle",
    descKey: "monitoringAdminDesc",
    tags: [
      "PROMETHEUS", "GRAFANA", "ZABBIX",
      "SENTINELONE", "SEKOIA",
      "M365 ADMIN", "GOOGLE WORKSPACE",
      "ENTRA ID", "INTUNE",
    ],
  },
];

function Expertise() {
  const { t } = useTranslation();
  usePageTitle('Compétences');

  return (
    <section className="skills-section">
      <div className="skills-header">
        <h1>{t("Compétences")}</h1>
        <div className="skills-rule" />
      </div>

      <div className="skills-grid">
        {categories.map((cat, i) => (
          <div key={i} className="skill-card">
            <div className="skill-card-icons">
              {cat.icons.map((icon, j) => (
                <FontAwesomeIcon key={j} icon={icon} />
              ))}
            </div>
            <h3 className="skill-card-title">{t(cat.titleKey)}</h3>
            <p className="skill-card-desc">{t(cat.descKey)}</p>
            <div className="skill-tags">
              {cat.tags.map((label, j) => (
                <Chip key={j} className="chip" label={label} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Expertise;
